import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericCRUDService } from '../../shared/services';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class CancelamentoMassaService extends GenericCRUDService {

    private workersUrl = `${environment.workersURL}/admin/cancelamento-em-massa`;

    constructor(http: HttpClient) {
        super(http);
    }

    cancelar(cancelamentoMassa: any): Observable<any> {
        return this.http.post<any>(this.workersUrl, cancelamentoMassa);
    }
}